// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Box } from '../../lib/base';
import NewFAQView from './NewFAQView';

export default function FAQView() {
  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <NewFAQView />
    </Box>
  );
}
